import { useMemo } from 'react';
import { Box } from '@mui/material';

export const getYouTubeEmbedUrl = (url: string) => {
  try {
    const u = new URL(url);
    if (u.hostname.includes('youtu.be')) {
      const id = u.pathname.replace('/', '');
      return id ? `https://www.youtube.com/embed/${id}` : '';
    }
    if (u.hostname.includes('youtube.com')) {
      const id = u.searchParams.get('v');
      const isEmbed = u.pathname.includes('/embed/');
      if (isEmbed) return url;
      return id ? `https://www.youtube.com/embed/${id}` : '';
    }
    return '';
  } catch {
    return '';
  }
};

export const YouTubeEmbed = ({
  url,
  title = 'Video'
}: {
  url: string;
  title?: string;
}) => {
  const embedUrl = useMemo(() => getYouTubeEmbedUrl(url), [url]);

  if (!embedUrl) return null;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 980,
        mx: 'auto',
        mb: 4,
        borderRadius: 4,
        overflow: 'hidden',
        border: '1px solid rgba(124,255,250,0.16)',
        background: 'rgba(12, 18, 20, 0.55)',
        boxShadow: '0 18px 70px rgba(0,0,0,0.45)'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          paddingTop: '56.25%' // 16:9
        }}
      >
        <Box
          component="iframe"
          title={title}
          src={embedUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            border: 0
          }}
        />
      </Box>
    </Box>
  );
};
